module.exports = __webpack_public_path__ + "static/img/jfyy.5fee459.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/jfyy.png
// module id = KwG7
// module chunks = 0